var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_621_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4444 9.33333V7.03889C19.4444 6.32391 19.3036 5.61594 19.03 4.95539C18.7564 4.29484 18.3553 3.69465 17.8498 3.18909C17.3442 2.68352 16.744 2.28249 16.0835 2.00888C15.4229 1.73527 14.7149 1.59444 14 1.59444C13.285 1.59444 12.577 1.73527 11.9165 2.00888C11.2559 2.28249 10.6557 2.68352 10.1502 3.18909C9.64461 3.69465 9.24357 4.29484 8.96996 4.95539C8.69635 5.61594 8.55553 6.32391 8.55553 7.03889V12.4833C8.55553 12.6896 8.63747 12.8874 8.78333 13.0333C8.9292 13.1792 9.12703 13.2611 9.33331 13.2611C9.53959 13.2611 9.73742 13.1792 9.88328 13.0333C10.0291 12.8874 10.1111 12.6896 10.1111 12.4833V10.8889H17.8889V9.33333H10.1111V7.03889C10.1111 6.00749 10.5208 5.01834 11.2501 4.28903C11.9794 3.55972 12.9686 3.15 14 3.15C15.0314 3.15 16.0205 3.55972 16.7498 4.28903C17.4791 5.01834 17.8889 6.00749 17.8889 7.03889V12.4444C17.8889 12.6507 17.9708 12.8486 18.1167 12.9944C18.2625 13.1403 18.4604 13.2222 18.6666 13.2222C18.8729 13.2222 19.0708 13.1403 19.2166 12.9944C19.3625 12.8486 19.4444 12.6507 19.4444 12.4444V10.8889H23.3333V24.8889H4.66664V10.8889H8.55553V9.33333H3.11108V24.9589C3.11108 25.3529 3.11108 26.4444 3.11108 26.4444C3.11108 26.4444 4.20265 26.4444 4.59664 26.4444C4.99063 26.4444 23.4033 26.4444 23.4033 26.4444C23.7973 26.4444 24.8889 26.4444 24.8889 26.4444C24.8889 26.4444 24.8889 25.3529 24.8889 24.9589V9.33333H19.4444Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_621_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBtn);
export default __webpack_public_path__ + "static/media/cartBtn.db963768b3469ae8920db2e54a36e23b.svg";
export { ForwardRef as ReactComponent };